import React from "react";

import api            from '../../../../../api';
import values         from '../../../../../values';
import Context        from '../../../../../context';
import FindDebtScreen from '..';

import { TModal                   } from '../../../../../types/common.type';
import { IFindDriverTransactions  } from '../../../../../types/common.interface';
import { useQuery, UseQueryResult } from 'react-query';

const DriverTransactionContainer: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [showModal, setShowModal] = React.useState<TModal>("NONE");
  const [selected, setSelected] = React.useState<any>();

  const [requestDriverTransaction, setRequestDriverTransaction] =
    React.useState<IFindDriverTransactions>({
      page: 1,
      limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
    });

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------------ Start Call API -------------------------------------------------

  // ? Panel-wide academic year (سال تحصیلی). It has to be in the query key as well as the request, otherwise
  // ? react-query serves the previous year's cached rows when the year is switched.
  const { selectedYear } = React.useContext(Context.AcademicYear);

  const driverTransaction: UseQueryResult<any, unknown> = useQuery(
    [values.useQueryKeys.driverTransaction, requestDriverTransaction, selectedYear?._id],
    () =>
      api.post.common.findDriverTransaction({
        ...requestDriverTransaction,
        academicYear: selectedYear?._id,
      })
  );

  // ! ------------------------------------------------- End Call API --------------------------------------------------
  // ! =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <Context.DriverTransactionScreen.Provider
      value={{
        selected,
        isLoading,
        showModal,
        driverTransaction,
        requestDriverTransaction,
        setSelected,
        setShowModal,
        setIsLoading,
        setRequestDriverTransaction,
      }}
    >
      <FindDebtScreen rqData={driverTransaction} showModalData={{}} />
    </Context.DriverTransactionScreen.Provider>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};

export default DriverTransactionContainer;
